import { Configuration, PublicClientApplication, RedirectRequest, SilentRequest } from '@azure/msal-browser';

const tenantId = process.env.REACT_APP_TENANT_ID ?? '';
const spaClientId = process.env.REACT_APP_SPA_CLIENT_ID ?? '';
const apiScope = process.env.REACT_APP_API_SCOPE ?? '';

const msalConfig: Configuration = {
  auth: {
    clientId: spaClientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: RedirectRequest = {
  scopes: [apiScope],
};

export const apiRequest: SilentRequest = {
  scopes: [apiScope],
  account: undefined,
};
